// extracted by mini-css-extract-plugin
export default {"SelectWrapper":"KnowledgeCheck_SelectWrapper__OQ1EH","DiscountBadge":"KnowledgeCheck_DiscountBadge__hUUm1"};